module.exports = __webpack_public_path__ + "static/media/05.79e1d7ae.png";